(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* R for Rabbit v4: a removed filter chip shrinks away while the grid reloads (CSS .is-removing). */
  const rfrMarkRemoving = (event) => {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    const chip = event.target instanceof Element ? event.target.closest('.rfr-active__chip') : null;
    if (chip) chip.classList.add('is-removing');
  };
  document.addEventListener('click', rfrMarkRemoving, true);
  document.addEventListener('keydown', rfrMarkRemoving, true);

  /* A chip reached with Tab inside the sideways chip strip is scrolled fully into view. */
  document.addEventListener('focusin', (event) => {
    const chip = event.target instanceof Element ? event.target.closest('.rfr-cband__chip') : null;
    if (!chip) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    chip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
